import { api } from "@/api/index.ts";
import { FirebaseConfig, StoreSettings } from "@/api/types.ts";

export async function fetchFirebaseConfig(): Promise<FirebaseConfig> {
  const response = await api.get<FirebaseConfig>('/api/public/firebase-config');
  return response.data;
}

export async function fetchStoreSettings(): Promise<StoreSettings> {
  const response = await api.get<StoreSettings>('/api/public/store-settings');
  return response.data;
}